import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { LogoMark } from "@/components/LogoMark";

export default function AuthCallback({ onAuth }) {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    const hash = location.hash || "";
    const sid = hash.includes("session_id=")
      ? new URLSearchParams(hash.replace(/^#/, "")).get("session_id")
      : null;
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    processed.current = true;
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sid });
        localStorage.setItem("tv_token", r.data.token);
        onAuth?.(r.data.user);
        toast.success(`Welcome, ${r.data.user.name.split(" ")[0]}`);
        const target = r.data.user.role === "admin" ? "/admin" : r.data.user.role === "buyer" ? "/orders" : "/";
        // Clear URL fragment before navigating
        window.history.replaceState({}, "", "/");
        navigate(target, { replace: true, state: { user: r.data.user } });
      } catch (err) {
        toast.error(formatError(err) || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, onAuth]);

  return (
    <main className="auth-page" data-testid="auth-callback-page">
      <div className="auth-art">
        <LogoMark />
        <h1 style={{ marginTop: 20 }}>Signing you in…</h1>
        <p>Finalising your Google session with True Vision.</p>
      </div>
      <div className="auth-form"><p className="muted">Please wait a moment.</p></div>
    </main>
  );
}
